import { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";

import Header from "../components/Header";
import Footer from "../components/Footer";

// =============== EMAIL VALIDATION FUNCTION ===============
const isValidEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

// const openDownloadPopup = (downloadId) => {
//   Swal.fire({
//     title: `
//       <div style="
//         display:flex;
//         align-items:center;
//         justify-content:center;
//         gap:10px;
//       ">
//         <i className="fa-solid fa-paper-plane" style="font-size:26px; color:#6C5CE7;"></i>
//         <span style="font-size:22px; font-weight:700;">Send File to Email</span>
//       </div>
//     `,

//     html: `
//       <div style="text-align:left; padding: 5px 3px 0 3px;">
        
//         <label style="font-size:15px; font-weight:600;">Full Name</label>
//        <input
//   id="swal-name"
//   type="text"
//   className="swal2-input"
//   placeholder="Enter your full name"
//   minlength="2"
//   maxlength="50"
//   style="
//     margin: 8px 0 16px 0;
//     height: 48px;
//     font-size: 15px;
//     border-radius: 12px;
//     padding: 12px;
//     background: #f7f7f7;
//     border: 1.6px solid #dcdcdc;
//     box-sizing: border-box;
//   "
// >


//         <label style="font-size:15px; font-weight:600;">Email Address</label>
//         <input id="swal-email" className="swal2-input" placeholder="you@example.com"
//           style="
//             margin: 8px 0 10px 0;
//             height: 48px;
//             font-size: 15px;
//             border-radius: 12px;
//             padding: 12px;
//             background:#f7f7f7;
//             border:1.6px solid #dcdcdc;
//           "
//         >
//       </div>
//     `,

//     width: "480px",
//     background: "rgba(255,255,255,0.90)",

//     showCancelButton: true,
//     confirmButtonText: "Download",
//     cancelButtonText: "Cancel",
//     confirmButtonColor: "#65ad4b",
//     cancelButtonColor: "#b5b5b5",

//     backdrop: `
//       rgba(255,255,255,0.35)
//       backdrop-filter: blur(14px)
//       -webkit-backdrop-filter: blur(14px)
//     `,

//     preConfirm: async () => {
//       const name = document.getElementById("swal-name").value.trim();
//       const email = document.getElementById("swal-email").value.trim();

//       if (!name) {
//         Swal.showValidationMessage("Please enter your full name");
//         return false;
//       }

//       if (!email) {
//         Swal.showValidationMessage("Please enter your email address");
//         return false;
//       }

//       if (!isValidEmail(email)) {
//         Swal.showValidationMessage("Please enter a valid email address");
//         return false;
//       }

//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_BACKEND_BASE_URL}/download/send-pdf/${downloadId}`,
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ name, email }),
//           }
//         );

//         const result = await response.json();

//         if (result.status !== 1) {
//           Swal.showValidationMessage(result.message || "Something went wrong");
//         }
//       } catch (error) {
//         Swal.showValidationMessage("Server error. Try again later.");
//       }
//     },
//   }).then((result) => {
//     if (result.isConfirmed) {
//       Swal.fire({
//         icon: "success",
//         title: "File sent!",
//         text: "Please check your email inbox.",
//         confirmButtonColor: "#65ad4b",
//       });
//     }
//   });
// };

const openDownloadPopup = (downloadId) => {
  Swal.fire({
    title: `
      <div style="
        display:flex;
        align-items:center;
        justify-content:center;
        gap:10px;
      ">
        <i class="fa-solid fa-paper-plane" style="font-size:26px; color:#6C5CE7;"></i>
        <span style="font-size:22px; font-weight:700;">Send File to Email</span>
      </div>
    `,

    html: `
      <div style="padding:14px 10px 0 10px; text-align:left;">

        <div style="display:block; gap:14px;">

          <div style="flex:1;">
            <label style="
              font-size:14px;
              font-weight:600;
              margin-bottom:6px;
              display:block;
            ">
              Full Name
            </label>
            <input
              id="swal-name"
              type="text"
              placeholder="Enter your full name"
              style="
                width:100%;
                height:46px;
                border-radius:12px;
                padding:12px;
                font-size:14px;
                background:#f7f7f7;
                border:1.5px solid #dcdcdc;
                box-sizing:border-box;
              "
            />
          </div>

          <div style="flex:1;padding: 20px 0 0 0;">
            <label style="
              font-size:14px;
              font-weight:600;
              margin-bottom:6px;
              display:block;
            ">
              Email Address
            </label>
            <input
              id="swal-email"
              type="email"
              placeholder="you@example.com"
              style="
                width:100%;
                height:46px;
                border-radius:12px;
                padding:12px;
                font-size:14px;
                background:#f7f7f7;
                border:1.5px solid #dcdcdc;
                box-sizing:border-box;
              "
            />
          </div>

        </div>

      </div>
    `,

    width: "500px",
    background: "rgba(255,255,255,0.95)",

    showCancelButton: true,
    confirmButtonText: "Download",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#65ad4b",
    cancelButtonColor: "#b5b5b5",

    backdrop: `
      rgba(255,255,255,0.35)
      backdrop-filter: blur(14px)
      -webkit-backdrop-filter: blur(14px)
    `,
    

    preConfirm: async () => {
      const name = document.getElementById("swal-name").value.trim();
      const email = document.getElementById("swal-email").value.trim();

      if (!name) {
        Swal.showValidationMessage("Please enter your full name");
        return false;
      }

      if (!email) {
        Swal.showValidationMessage("Please enter your email address");
        return false;
      }

      if (!isValidEmail(email)) {
        Swal.showValidationMessage("Please enter a valid email address");
        return false;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/download/send-pdf/${downloadId}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ name, email }),
          }
        );

        const result = await response.json();

        if (result.status !== 1) {
          Swal.showValidationMessage(result.message || "Something went wrong");
          return false;
        }
      } catch (error) {
        Swal.showValidationMessage("Server error. Try again later.");
        return false;
      }
    },
  }).then((result) => {
    if (result.isConfirmed) {
      Swal.fire({
        icon: "success",
        title: "File sent!",
        text: "Please check your email inbox.",
        confirmButtonColor: "#65ad4b",
      });
    }
  });
};



// ================ PAGE COMPONENT =======================
export default function Achievements() {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [expandedDesc, setExpandedDesc] = useState({});

  const TEXT_LIMIT = 160;

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  const [blog, setBlog] = useState([]);
  const getBlogData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/blog`
      );
      if (res.status === 200) {
        setBlog(res.data.data);
      } else {
        setBlog([]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getBlogData();
  }, []);

  const [download, setDownload] = useState([]);
  const getDownloadData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/download`
      );
      if (res.status === 200) {
        setDownload(res.data.data);
      } else {
        setDownload([]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getDownloadData();
  }, []);
  const toggleReadMore = (id) => {
    setExpandedDesc((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  return (
    <>
      <Header />

      {/* HERO */}
      <section
        className="about-hero"
        style={{ backgroundImage: "url('/assets/img/Achievements.jpg')" }}
        aria-label="Knowledge center hero"
      >
        <div className="overlay" />
        <div className="about-hero-text">
          <h1 className="fade-up">Knowledge Center</h1>
          <p className="fade-up delay-1">
            Practical tax, GST & compliance insights for business owners.
          </p>
        </div>
      </section>

      <main className="kc-main">
        {/* ===== Editor’s Picks ===== */}
        <section className="kc-module kc-editors">
          <div className="kc-inner">
            <div className="kc-module-head">
              <h2>Editor’s picks</h2>
              <p className="muted">
                Most requested explanations from our clients
              </p>
              <p className="kc-lead">
                Start with these guides if you want a quick overview of the most
                common tax and compliance questions.
              </p>

              <div className="kc-quick-request">
                <span>Looking for something specific?</span>

                <Link
                  to="/contactus"
                  className="apply-btn"
                  onClick={() => window.scrollTo(0, 0)}
                  style={{
                    display: "block",
                    marginTop: "12px",
                    width: "fit-content",
                  }}
                >
                  Send your topic request
                </Link>
              </div>
            </div>

            <div className="kc-cards">
              <article
                className="kc-card slide-up"
                style={{ animationDelay: "0.06s" }}
              >
                <div className="card-top">
                  <span className="tag">GST · Guide</span>
                </div>
                <h3>
                  How GST works for service providers and small businesses
                </h3>
                <p className="excerpt">
                  A clear and practical overview of GST registration, invoicing,
                  returns, and ongoing compliance requirements applicable to
                  service providers and small businesses. Explained as per
                  current GST laws
                </p>
                {/* <ul className="meta">
                  <li>🕒 8 min read</li>
                  <li>Updated for latest rules</li>
                </ul> */}
              </article>

              <article
                className="kc-card slide-up"
                style={{ animationDelay: "0.12s" }}
              >
                <div className="card-top">
                  <span className="tag">Income Tax</span>
                </div>
                <h3>Old vs New tax regime – which is better for you?</h3>
                <p className="excerpt">
                  A straightforward comparison of the old and new tax regimes
                  with illustrations to help individuals and professionals make
                  informed tax decisions. Updated as per latest Income Tax rules
                </p>
                {/* <ul className="meta">
                  <li>🕒 6 min read</li>
                  <li>Calculator included</li>
                </ul> */}
              </article>

              <article
                className="kc-card slide-up"
                style={{ animationDelay: "0.18s" }}
              >
                <div className="card-top">
                  <span className="tag">ROC & Company Law</span>
                </div>
                <h3>Annual compliances for a private limited company</h3>
                <p className="excerpt">
                  A simplified guide covering mandatory ROC filings, board
                  meetings, statutory registers, and annual timelines to help
                  companies remain fully compliant. As per Companies Act, 2013
                </p>
                {/* <ul className="meta">
                  <li>🕒 7 min read</li>
                  <li>Downloadable tracker</li>
                </ul> */}
              </article>
            </div>
          </div>
        </section>

        <div className="separator" />

        {/* ===== Latest Articles ===== */}
        <section className="kc-module kc-latest">
          <div className="kc-inner">
            <h2>Latest articles</h2>
            <p className="muted">
              Newly added explanations & updates — short notes to understand one
              concept.
            </p>

            <div className="kc-grid">
              {blog.map((dataa, i) => (
                <article
                  key={i}
                  className="mini-card slide-up"
                  style={{ animationDelay: "0.06s" }}
                >
                  {/* IMAGE */}
                  <div className="mini-img">
                    <img
                      src={`${process.env.REACT_APP_BACKEND_BASE_URL_FILES}/uploads/blog/${dataa.photo}`}
                      alt={`${dataa.title}`}
                    />
                  </div>

                  <div className="mini-top mt-2">
                    <span className="download-kind">{dataa.title}</span>
                  </div>

                  {/* DESCRIPTION */}
                  <p className="blog-desc">
                    {expandedIndex === i
                      ? dataa.description
                      : dataa.description.length > TEXT_LIMIT
                        ? `${dataa.description.slice(0, TEXT_LIMIT)}...`
                        : dataa.description}
                  </p>

                  {/* READ MORE */}
                  {dataa.description.length > TEXT_LIMIT && (
                    <button
                      className="read-more-btn"
                      onClick={() =>
                        setExpandedIndex(expandedIndex === i ? null : i)
                      }
                    >
                      {/* {expandedIndex === i ? "Read less ↑" : "Read more →"} */}
                    </button>
                  )}

                  <div className="mini-footer">
                    <p className="meta muted">{formatDate(dataa.created_at)}</p>

                    <button
                      className="open-full-btn"
                      onClick={() => setSelectedBlog(dataa)}
                    >
                      read more →
                    </button>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <div className="separator" />

        {/* ===== Downloads ===== */}
        <section className="kc-module kc-downloads">
          <div className="kc-inner">
            <h2>Downloads & tools</h2>
            <p className="muted">
              Ready checklists & templates to use directly.
            </p>

            <div className="download-grid">
              {download.map((dataa, i) => {
                const isExpanded = expandedDesc[dataa.id];
                const isLong = dataa.description.length > 120;

                return (
                  <div
                    key={dataa.id}
                    className="download-card slide-up"
                    style={{ animationDelay: `${i * 0.06}s` }}
                  >
                    {/* Type / Title */}
                    <div className="download-kind">
                      <h6>{dataa.title}</h6>
                    </div>

                    {/* Description */}
                    <p>
                      {isExpanded || !isLong
                        ? dataa.description
                        : `${dataa.description.slice(0, 120)}...`}
                    </p>

                    {isLong && (
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        style={{ fontSize: "14px" }}
                        onClick={() => toggleReadMore(dataa.id)}
                      >
                        {isExpanded ? "Read Less" : "Read More"}
                      </button>
                    )}

                    {/* Date */}
                    <p className="meta muted">
                      {new Date(dataa.created_at).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </p>

                    {/* Download Button */}
                    <button
                      className="apply-btn"
                      onClick={() => openDownloadPopup(dataa.id)}
                    >
                      Download →
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <div className="separator" />

        {/* ===== FAQs ===== */}
        {/* <section className="kc-module kc-faqs">
          <div className="kc-inner">
            <h2>FAQs — Questions we often get</h2>
            <p className="muted">Quick reference for common doubts.</p>

            <div className="faq-list">
              {[
                {
                  q: "When is GST registration mandatory?",
                  a: "GST registration becomes mandatory once turnover crosses the prescribed limits or in specific cases such as inter-state supply, e-commerce operations, or liability under reverse charge.",
                },
                {
                  q: "What happens if I miss TDS payment?",
                  a: "Delay in TDS payment may attract interest, penalties, late fees, and disallowance of the related expense under the Income Tax Act.",
                },
                {
                  q: "Annual compliances for private limited?",
                  a: "Annual compliances include filing AOC-4 and MGT-7, conducting board and AGM meetings, auditor appointment, maintenance of statutory registers, and mandatory disclosures.",
                },
                {
                  q: "Can you review my past returns?",
                  a: "Yes, we conduct detailed compliance reviews of past returns to identify risks, defaults, and recommend corrective actions.",
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className={`faq-item ${openFaq === i ? "open" : ""}`}
                >
                  <button className="faq-q" onClick={() => toggleFaq(i)}>
                    <span>
                      {i + 1}. {item.q}
                    </span>
                    <span className="faq-sign">
                      {openFaq === i ? "−" : "+"}
                    </span>
                  </button>

                  <div className="faq-a">
                    <p>{item.a}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="support-block">
              <h3>Support</h3>
              <p>
                Need specific help? Share your business details and returns —
                we’ll guide you.
              </p>

              <Link
                id="request"
                className="apply-btn"
                to="/contactus"
                onClick={() => window.scrollTo(0, 0)}
              >
                Book a clarity call →
              </Link>
            </div>
          </div>
        </section> */}
      </main>

      {selectedBlog && (
        <div className="blog-modal">
          <div className="blog-modal-content">
            <button
              className="close-modal"
              onClick={() => setSelectedBlog(null)}
            >
              ✕
            </button>

            {/* ✅ Dynamic Image */}
            <img
              src={`${process.env.REACT_APP_BACKEND_BASE_URL_FILES}/uploads/blog/${selectedBlog.photo}`}
              alt={selectedBlog.title}
              onError={(e) => {
                e.target.src = "/assets/img/auditteam.jpg"; // fallback image
              }}
            />

            <h2>{selectedBlog.title}</h2>

            <p className="meta muted">{formatDate(selectedBlog.created_at)}</p>

            <p className="full-description">{selectedBlog.description}</p>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}
